module.exports = __webpack_public_path__ + "static/media/more-account.092f9274.svg";